export const styles = {
  containerStyle: {
    cursor: "pointer",
    border: "1px solid black",
    width: "30px"
  }
};
